/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BatchFavoritePlayersDto,
  BatchFavoritePlayersResultDto,
  ChangePasswordDto,
  CheckFavoritedStatusDto,
  DeleteUserFavoritePlayersBatchParams,
  DeleteUserFavoritePlayersClearForTypeParams,
  DeleteUserFavoritePlayersPlayerIdParams,
  ErrorResult,
  FavoriteCountsByTypeDto,
  FavoritePlayerDto,
  GetUserFavoritePlayersCountParams,
  GetUserFavoritePlayersIdsParams,
  GetUserFavoritePlayersParams,
  GetUserFavoritePlayersPlayerIdIsFavoritedParams,
  GetUserIdRecentGamesParams,
  LoginDto,
  LoginResponseDto,
  PostUserFavoritePlayersBatchParams,
  PostUserFavoritePlayersCheckStatus200One,
  PostUserFavoritePlayersCheckStatus200Three,
  PostUserFavoritePlayersCheckStatus200Two,
  PostUserFavoritePlayersCheckStatusParams,
  PostUserFavoritePlayersPlayerIdParams,
  ProblemDetails,
  RecentGameLeagueDto,
  ReferralViewResponse,
  RegisterAndCreateTeamDto,
  RequestPasswordResetDto,
  ResetPasswordDto,
  SendReferralDto,
  SetSandboxTeamStrengthDto,
  TeamIdentity,
  User,
  UserDashboardResponse,
  UserSessionResponse,
  UserSettingsDto,
  UserSettingsViewResponse
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Gets the current authenticated user: account fields + leagues + settings
(the app's session bootstrap). Replaces the legacy
GET /User/CurrentUser?componentsJson={Leagues,Settings} path.
 */
export const getUserCurrentUser = (

 signal?: AbortSignal
) => {


      return fetcher<UserSessionResponse>(
      {url: `/User/CurrentUser`, method: 'GET', signal
    },
      );
    }




export const getGetUserCurrentUserQueryKey = () => {
    return [
    `/User/CurrentUser`
    ] as const;
    }


export const getGetUserCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getUserCurrentUser>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCurrentUser>>> = ({ signal }) => getUserCurrentUser(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUserCurrentUser>>>
export type GetUserCurrentUserQueryError = ProblemDetails


export function useGetUserCurrentUser<TData = Awaited<ReturnType<typeof getUserCurrentUser>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getUserCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserCurrentUser<TData = Awaited<ReturnType<typeof getUserCurrentUser>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getUserCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserCurrentUser<TData = Awaited<ReturnType<typeof getUserCurrentUser>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the current authenticated user: account fields + leagues + settings
(the app's session bootstrap). Replaces the legacy
GET /User/CurrentUser?componentsJson={Leagues,Settings} path.
 */

export function useGetUserCurrentUser<TData = Awaited<ReturnType<typeof getUserCurrentUser>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets a user by ID: flat account fields. Private fields (email/last logon)
are included only when the requester is the user themselves (owner-gated,
parity with the legacy path).
 */
export const getUserId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<User>(
      {url: `/User/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetUserIdQueryKey = (id: number,) => {
    return [
    `/User/${id}`
    ] as const;
    }


export const getGetUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserId>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserId>>> = ({ signal }) => getUserId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserId>>>
export type GetUserIdQueryError = ProblemDetails


export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets a user by ID: flat account fields. Private fields (email/last logon)
are included only when the requester is the user themselves (owner-gated,
parity with the legacy path).
 */

export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a user's dashboard data (flat view-shaped response).
Email/LastLogon populated only for admin requesters.
 */
export const getUserIdDashboard = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<UserDashboardResponse>(
      {url: `/User/${id}/Dashboard`, method: 'GET', signal
    },
      );
    }




export const getGetUserIdDashboardQueryKey = (id: number,) => {
    return [
    `/User/${id}/Dashboard`
    ] as const;
    }


export const getGetUserIdDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdDashboard>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdDashboardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdDashboard>>> = ({ signal }) => getUserIdDashboard(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdDashboard>>>
export type GetUserIdDashboardQueryError = ProblemDetails


export function useGetUserIdDashboard<TData = Awaited<ReturnType<typeof getUserIdDashboard>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdDashboard>>,
          TError,
          Awaited<ReturnType<typeof getUserIdDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdDashboard<TData = Awaited<ReturnType<typeof getUserIdDashboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdDashboard>>,
          TError,
          Awaited<ReturnType<typeof getUserIdDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdDashboard<TData = Awaited<ReturnType<typeof getUserIdDashboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's dashboard data (flat view-shaped response).
Email/LastLogon populated only for admin requesters.
 */

export function useGetUserIdDashboard<TData = Awaited<ReturnType<typeof getUserIdDashboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdDashboardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a user's leagues.
 */
export const getUserIdLeagues = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamIdentity[]>(
      {url: `/User/${id}/leagues`, method: 'GET', signal
    },
      );
    }




export const getGetUserIdLeaguesQueryKey = (id: number,) => {
    return [
    `/User/${id}/leagues`
    ] as const;
    }


export const getGetUserIdLeaguesQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdLeagues>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdLeaguesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdLeagues>>> = ({ signal }) => getUserIdLeagues(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdLeaguesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdLeagues>>>
export type GetUserIdLeaguesQueryError = ProblemDetails


export function useGetUserIdLeagues<TData = Awaited<ReturnType<typeof getUserIdLeagues>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdLeagues>>,
          TError,
          Awaited<ReturnType<typeof getUserIdLeagues>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdLeagues<TData = Awaited<ReturnType<typeof getUserIdLeagues>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdLeagues>>,
          TError,
          Awaited<ReturnType<typeof getUserIdLeagues>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdLeagues<TData = Awaited<ReturnType<typeof getUserIdLeagues>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's leagues.
 */

export function useGetUserIdLeagues<TData = Awaited<ReturnType<typeof getUserIdLeagues>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdLeagues>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdLeaguesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets authentication token for a user on login
 */
export const postUserLogin = (
    loginDto?: LoginDto,
 signal?: AbortSignal
) => {


      return fetcher<LoginResponseDto>(
      {url: `/User/Login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginDto, signal
    },
      );
    }




export const getPostUserLoginMutationKey = () => ['postUserLogin'] as const;

export const getPostUserLoginMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,PostUserLoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,PostUserLoginMutationVariables, TContext> => {

const mutationKey = getPostUserLoginMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserLogin>>, PostUserLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postUserLogin>>>
    export type PostUserLoginMutationBody = LoginDto | undefined
    export type PostUserLoginMutationError = ErrorResult
    export type PostUserLoginMutationVariables = {data?: LoginDto}

    /**
 * @summary Gets authentication token for a user on login
 */
export const usePostUserLogin = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,PostUserLoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserLogin>>,
        TError,
        PostUserLoginMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserLoginMutationOptions(options), queryClient);
    }
    /**
 * @summary Register and Create a Team
 */
export const postUserRegisterAndCreateTeam = (
    registerAndCreateTeamDto?: RegisterAndCreateTeamDto,
 signal?: AbortSignal
) => {


      return fetcher<number>(
      {url: `/User/RegisterAndCreateTeam`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerAndCreateTeamDto, signal
    },
      );
    }




export const getPostUserRegisterAndCreateTeamMutationKey = () => ['postUserRegisterAndCreateTeam'] as const;

export const getPostUserRegisterAndCreateTeamMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>, TError,PostUserRegisterAndCreateTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>, TError,PostUserRegisterAndCreateTeamMutationVariables, TContext> => {

const mutationKey = getPostUserRegisterAndCreateTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>, PostUserRegisterAndCreateTeamMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserRegisterAndCreateTeam(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserRegisterAndCreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>>
    export type PostUserRegisterAndCreateTeamMutationBody = RegisterAndCreateTeamDto | undefined
    export type PostUserRegisterAndCreateTeamMutationError = ErrorResult
    export type PostUserRegisterAndCreateTeamMutationVariables = {data?: RegisterAndCreateTeamDto}

    /**
 * @summary Register and Create a Team
 */
export const usePostUserRegisterAndCreateTeam = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>, TError,PostUserRegisterAndCreateTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserRegisterAndCreateTeam>>,
        TError,
        PostUserRegisterAndCreateTeamMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserRegisterAndCreateTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets a pending email address for the current user
 */
export const postUserSetPendingEmail = (
    postUserSetPendingEmailBody?: string,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/SetPendingEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserSetPendingEmailBody, signal
    },
      );
    }




export const getPostUserSetPendingEmailMutationKey = () => ['postUserSetPendingEmail'] as const;

export const getPostUserSetPendingEmailMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSetPendingEmail>>, TError,PostUserSetPendingEmailMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserSetPendingEmail>>, TError,PostUserSetPendingEmailMutationVariables, TContext> => {

const mutationKey = getPostUserSetPendingEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSetPendingEmail>>, PostUserSetPendingEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserSetPendingEmail(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserSetPendingEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSetPendingEmail>>>
    export type PostUserSetPendingEmailMutationBody = string | undefined
    export type PostUserSetPendingEmailMutationError = ErrorResult | ProblemDetails
    export type PostUserSetPendingEmailMutationVariables = {data?: string}

    /**
 * @summary Sets a pending email address for the current user
 */
export const usePostUserSetPendingEmail = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSetPendingEmail>>, TError,PostUserSetPendingEmailMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserSetPendingEmail>>,
        TError,
        PostUserSetPendingEmailMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserSetPendingEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Resend verification email address for the current user
 */
export const postUserResendVerificationEmail = (

 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/ResendVerificationEmail`, method: 'POST', signal
    },
      );
    }




export const getPostUserResendVerificationEmailMutationKey = () => ['postUserResendVerificationEmail'] as const;

export const getPostUserResendVerificationEmailMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserResendVerificationEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserResendVerificationEmail>>, TError,void, TContext> => {

const mutationKey = getPostUserResendVerificationEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserResendVerificationEmail>>, void> = () => {


          return  postUserResendVerificationEmail()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserResendVerificationEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postUserResendVerificationEmail>>>

    export type PostUserResendVerificationEmailMutationError = ErrorResult | ProblemDetails


    /**
 * @summary Resend verification email address for the current user
 */
export const usePostUserResendVerificationEmail = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserResendVerificationEmail>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserResendVerificationEmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostUserResendVerificationEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Verifies an email change using a verification token
 */
export const postUserVerifyEmailChangeToken = (
    token: string,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/VerifyEmailChange/${token}`, method: 'POST', signal
    },
      );
    }




export const getPostUserVerifyEmailChangeTokenMutationKey = () => ['postUserVerifyEmailChangeToken'] as const;

export const getPostUserVerifyEmailChangeTokenMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>, TError,PostUserVerifyEmailChangeTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>, TError,PostUserVerifyEmailChangeTokenMutationVariables, TContext> => {

const mutationKey = getPostUserVerifyEmailChangeTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>, PostUserVerifyEmailChangeTokenMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  postUserVerifyEmailChangeToken(token,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserVerifyEmailChangeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>>

    export type PostUserVerifyEmailChangeTokenMutationError = ErrorResult
    export type PostUserVerifyEmailChangeTokenMutationVariables = {token: string}

    /**
 * @summary Verifies an email change using a verification token
 */
export const usePostUserVerifyEmailChangeToken = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>, TError,PostUserVerifyEmailChangeTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserVerifyEmailChangeToken>>,
        TError,
        PostUserVerifyEmailChangeTokenMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserVerifyEmailChangeTokenMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancels a pending email change for the current user
 */
export const deleteUserClearPendingEmail = (

 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/ClearPendingEmail`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteUserClearPendingEmailMutationKey = () => ['deleteUserClearPendingEmail'] as const;

export const getDeleteUserClearPendingEmailMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserClearPendingEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserClearPendingEmail>>, TError,void, TContext> => {

const mutationKey = getDeleteUserClearPendingEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserClearPendingEmail>>, void> = () => {


          return  deleteUserClearPendingEmail()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserClearPendingEmailMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserClearPendingEmail>>>

    export type DeleteUserClearPendingEmailMutationError = ErrorResult | ProblemDetails


    /**
 * @summary Cancels a pending email change for the current user
 */
export const useDeleteUserClearPendingEmail = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserClearPendingEmail>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserClearPendingEmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteUserClearPendingEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Changes the password for the current user
 */
export const postUserChangePassword = (
    changePasswordDto?: ChangePasswordDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/ChangePassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordDto, signal
    },
      );
    }




export const getPostUserChangePasswordMutationKey = () => ['postUserChangePassword'] as const;

export const getPostUserChangePasswordMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserChangePassword>>, TError,PostUserChangePasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserChangePassword>>, TError,PostUserChangePasswordMutationVariables, TContext> => {

const mutationKey = getPostUserChangePasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserChangePassword>>, PostUserChangePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserChangePassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postUserChangePassword>>>
    export type PostUserChangePasswordMutationBody = ChangePasswordDto | undefined
    export type PostUserChangePasswordMutationError = ErrorResult | ProblemDetails
    export type PostUserChangePasswordMutationVariables = {data?: ChangePasswordDto}

    /**
 * @summary Changes the password for the current user
 */
export const usePostUserChangePassword = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserChangePassword>>, TError,PostUserChangePasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserChangePassword>>,
        TError,
        PostUserChangePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserChangePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Request a password reset email
 */
export const postUserRequestPasswordReset = (
    requestPasswordResetDto?: RequestPasswordResetDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/RequestPasswordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestPasswordResetDto, signal
    },
      );
    }




export const getPostUserRequestPasswordResetMutationKey = () => ['postUserRequestPasswordReset'] as const;

export const getPostUserRequestPasswordResetMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserRequestPasswordReset>>, TError,PostUserRequestPasswordResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserRequestPasswordReset>>, TError,PostUserRequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getPostUserRequestPasswordResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserRequestPasswordReset>>, PostUserRequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserRequestPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserRequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof postUserRequestPasswordReset>>>
    export type PostUserRequestPasswordResetMutationBody = RequestPasswordResetDto | undefined
    export type PostUserRequestPasswordResetMutationError = ErrorResult
    export type PostUserRequestPasswordResetMutationVariables = {data?: RequestPasswordResetDto}

    /**
 * @summary Request a password reset email
 */
export const usePostUserRequestPasswordReset = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserRequestPasswordReset>>, TError,PostUserRequestPasswordResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserRequestPasswordReset>>,
        TError,
        PostUserRequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserRequestPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * @summary Reset password using a valid reset token
 */
export const postUserResetPassword = (
    resetPasswordDto?: ResetPasswordDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/ResetPassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordDto, signal
    },
      );
    }




export const getPostUserResetPasswordMutationKey = () => ['postUserResetPassword'] as const;

export const getPostUserResetPasswordMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserResetPassword>>, TError,PostUserResetPasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserResetPassword>>, TError,PostUserResetPasswordMutationVariables, TContext> => {

const mutationKey = getPostUserResetPasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserResetPassword>>, PostUserResetPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserResetPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postUserResetPassword>>>
    export type PostUserResetPasswordMutationBody = ResetPasswordDto | undefined
    export type PostUserResetPasswordMutationError = ErrorResult
    export type PostUserResetPasswordMutationVariables = {data?: ResetPasswordDto}

    /**
 * @summary Reset password using a valid reset token
 */
export const usePostUserResetPassword = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserResetPassword>>, TError,PostUserResetPasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserResetPassword>>,
        TError,
        PostUserResetPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserResetPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary View-shaped settings payload for the user/settings page (the user's
account fields + settings). Owner-or-admin only. Replaces the legacy
GET /User/{id}?componentsJson={Settings:{}} path.
 */
export const getUserIdSettings = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<UserSettingsViewResponse>(
      {url: `/User/${id}/settings`, method: 'GET', signal
    },
      );
    }




export const getGetUserIdSettingsQueryKey = (id: number,) => {
    return [
    `/User/${id}/settings`
    ] as const;
    }


export const getGetUserIdSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdSettings>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdSettingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdSettings>>> = ({ signal }) => getUserIdSettings(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdSettings>>>
export type GetUserIdSettingsQueryError = ProblemDetails


export function useGetUserIdSettings<TData = Awaited<ReturnType<typeof getUserIdSettings>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdSettings>>,
          TError,
          Awaited<ReturnType<typeof getUserIdSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdSettings<TData = Awaited<ReturnType<typeof getUserIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdSettings>>,
          TError,
          Awaited<ReturnType<typeof getUserIdSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdSettings<TData = Awaited<ReturnType<typeof getUserIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary View-shaped settings payload for the user/settings page (the user's
account fields + settings). Owner-or-admin only. Replaces the legacy
GET /User/{id}?componentsJson={Settings:{}} path.
 */

export function useGetUserIdSettings<TData = Awaited<ReturnType<typeof getUserIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdSettingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Saves a user's settings
 */
export const putUserIdSettings = (
    id: number,
    userSettingsDto?: UserSettingsDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/${id}/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userSettingsDto, signal
    },
      );
    }




export const getPutUserIdSettingsMutationKey = () => ['putUserIdSettings'] as const;

export const getPutUserIdSettingsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserIdSettings>>, TError,PutUserIdSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserIdSettings>>, TError,PutUserIdSettingsMutationVariables, TContext> => {

const mutationKey = getPutUserIdSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserIdSettings>>, PutUserIdSettingsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putUserIdSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutUserIdSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putUserIdSettings>>>
    export type PutUserIdSettingsMutationBody = UserSettingsDto | undefined
    export type PutUserIdSettingsMutationError = ErrorResult | ProblemDetails
    export type PutUserIdSettingsMutationVariables = {id: number;data?: UserSettingsDto}

    /**
 * @summary Saves a user's settings
 */
export const usePutUserIdSettings = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserIdSettings>>, TError,PutUserIdSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserIdSettings>>,
        TError,
        PutUserIdSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getPutUserIdSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Changes the current user's sandbox team strength for next season.
 */
export const putUserSandboxTeamStrength = (
    setSandboxTeamStrengthDto?: SetSandboxTeamStrengthDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/Sandbox/TeamStrength`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setSandboxTeamStrengthDto, signal
    },
      );
    }




export const getPutUserSandboxTeamStrengthMutationKey = () => ['putUserSandboxTeamStrength'] as const;

export const getPutUserSandboxTeamStrengthMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSandboxTeamStrength>>, TError,PutUserSandboxTeamStrengthMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserSandboxTeamStrength>>, TError,PutUserSandboxTeamStrengthMutationVariables, TContext> => {

const mutationKey = getPutUserSandboxTeamStrengthMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserSandboxTeamStrength>>, PutUserSandboxTeamStrengthMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putUserSandboxTeamStrength(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutUserSandboxTeamStrengthMutationResult = NonNullable<Awaited<ReturnType<typeof putUserSandboxTeamStrength>>>
    export type PutUserSandboxTeamStrengthMutationBody = SetSandboxTeamStrengthDto | undefined
    export type PutUserSandboxTeamStrengthMutationError = ErrorResult | ProblemDetails
    export type PutUserSandboxTeamStrengthMutationVariables = {data?: SetSandboxTeamStrengthDto}

    /**
 * @summary Changes the current user's sandbox team strength for next season.
 */
export const usePutUserSandboxTeamStrength = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSandboxTeamStrength>>, TError,PutUserSandboxTeamStrengthMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserSandboxTeamStrength>>,
        TError,
        PutUserSandboxTeamStrengthMutationVariables,
        TContext
      > => {
      return useMutation(getPutUserSandboxTeamStrengthMutationOptions(options), queryClient);
    }
    /**
 * @summary Get current user's favorite player IDs, optionally filtered by favorite type.
 */
export const getUserFavoritePlayersIds = (
    params?: GetUserFavoritePlayersIdsParams,
 signal?: AbortSignal
) => {


      return fetcher<number[]>(
      {url: `/User/FavoritePlayers/Ids`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserFavoritePlayersIdsQueryKey = (params?: GetUserFavoritePlayersIdsParams,) => {
    return [
    `/User/FavoritePlayers/Ids`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserFavoritePlayersIdsQueryOptions = <TData = Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError = ProblemDetails>(params?: GetUserFavoritePlayersIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFavoritePlayersIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>> = ({ signal }) => getUserFavoritePlayersIds(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFavoritePlayersIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>>
export type GetUserFavoritePlayersIdsQueryError = ProblemDetails


export function useGetUserFavoritePlayersIds<TData = Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError = ProblemDetails>(
 params: undefined |  GetUserFavoritePlayersIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersIds>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersIds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersIds<TData = Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersIds>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersIds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersIds<TData = Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's favorite player IDs, optionally filtered by favorite type.
 */

export function useGetUserFavoritePlayersIds<TData = Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersIds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFavoritePlayersIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get current user's favorite players with player details, optionally filtered by favorite type.
 */
export const getUserFavoritePlayers = (
    params?: GetUserFavoritePlayersParams,
 signal?: AbortSignal
) => {


      return fetcher<FavoritePlayerDto[]>(
      {url: `/User/FavoritePlayers`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserFavoritePlayersQueryKey = (params?: GetUserFavoritePlayersParams,) => {
    return [
    `/User/FavoritePlayers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserFavoritePlayersQueryOptions = <TData = Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError = ProblemDetails>(params?: GetUserFavoritePlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFavoritePlayersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFavoritePlayers>>> = ({ signal }) => getUserFavoritePlayers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFavoritePlayersQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFavoritePlayers>>>
export type GetUserFavoritePlayersQueryError = ProblemDetails


export function useGetUserFavoritePlayers<TData = Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError = ProblemDetails>(
 params: undefined |  GetUserFavoritePlayersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayers>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayers<TData = Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayers>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayers<TData = Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's favorite players with player details, optionally filtered by favorite type.
 */

export function useGetUserFavoritePlayers<TData = Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFavoritePlayersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get current user's favorite counts grouped by favorite type.
 */
export const getUserFavoritePlayersCounts = (

 signal?: AbortSignal
) => {


      return fetcher<FavoriteCountsByTypeDto>(
      {url: `/User/FavoritePlayers/Counts`, method: 'GET', signal
    },
      );
    }




export const getGetUserFavoritePlayersCountsQueryKey = () => {
    return [
    `/User/FavoritePlayers/Counts`
    ] as const;
    }


export const getGetUserFavoritePlayersCountsQueryOptions = <TData = Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFavoritePlayersCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>> = ({ signal }) => getUserFavoritePlayersCounts(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFavoritePlayersCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>>
export type GetUserFavoritePlayersCountsQueryError = ProblemDetails


export function useGetUserFavoritePlayersCounts<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersCounts<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersCounts<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's favorite counts grouped by favorite type.
 */

export function useGetUserFavoritePlayersCounts<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFavoritePlayersCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check if a specific player is favorited.
If favoriteType is null, checks across all types.
 */
export const getUserFavoritePlayersPlayerIdIsFavorited = (
    playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams,
 signal?: AbortSignal
) => {


      return fetcher<boolean>(
      {url: `/User/FavoritePlayers/${playerId}/IsFavorited`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserFavoritePlayersPlayerIdIsFavoritedQueryKey = (playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams,) => {
    return [
    `/User/FavoritePlayers/${playerId}/IsFavorited`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserFavoritePlayersPlayerIdIsFavoritedQueryOptions = <TData = Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError = ProblemDetails>(playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFavoritePlayersPlayerIdIsFavoritedQueryKey(playerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>> = ({ signal }) => getUserFavoritePlayersPlayerIdIsFavorited(playerId,params, signal);





   return  { queryKey, queryFn, enabled: playerId !== null && playerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFavoritePlayersPlayerIdIsFavoritedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>>
export type GetUserFavoritePlayersPlayerIdIsFavoritedQueryError = ProblemDetails


export function useGetUserFavoritePlayersPlayerIdIsFavorited<TData = Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError = ProblemDetails>(
 playerId: number,
    params: undefined |  GetUserFavoritePlayersPlayerIdIsFavoritedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersPlayerIdIsFavorited<TData = Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError = ProblemDetails>(
 playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersPlayerIdIsFavorited<TData = Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError = ProblemDetails>(
 playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check if a specific player is favorited.
If favoriteType is null, checks across all types.
 */

export function useGetUserFavoritePlayersPlayerIdIsFavorited<TData = Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError = ProblemDetails>(
 playerId: number,
    params?: GetUserFavoritePlayersPlayerIdIsFavoritedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersPlayerIdIsFavorited>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFavoritePlayersPlayerIdIsFavoritedQueryOptions(playerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check favorited status for multiple players in a specific favorite type context.
Efficient for rendering UI (e.g., showing favorite icons on player lists).
 */
export const postUserFavoritePlayersCheckStatus = (
    checkFavoritedStatusDto?: CheckFavoritedStatusDto,
    params?: PostUserFavoritePlayersCheckStatusParams,
 signal?: AbortSignal
) => {


      return fetcher<PostUserFavoritePlayersCheckStatus200One | PostUserFavoritePlayersCheckStatus200Two | PostUserFavoritePlayersCheckStatus200Three>(
      {url: `/User/FavoritePlayers/CheckStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkFavoritedStatusDto,
        params, signal
    },
      );
    }




export const getPostUserFavoritePlayersCheckStatusMutationKey = () => ['postUserFavoritePlayersCheckStatus'] as const;

export const getPostUserFavoritePlayersCheckStatusMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>, TError,PostUserFavoritePlayersCheckStatusMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>, TError,PostUserFavoritePlayersCheckStatusMutationVariables, TContext> => {

const mutationKey = getPostUserFavoritePlayersCheckStatusMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>, PostUserFavoritePlayersCheckStatusMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  postUserFavoritePlayersCheckStatus(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserFavoritePlayersCheckStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>>
    export type PostUserFavoritePlayersCheckStatusMutationBody = CheckFavoritedStatusDto | undefined
    export type PostUserFavoritePlayersCheckStatusMutationError = ErrorResult | ProblemDetails
    export type PostUserFavoritePlayersCheckStatusMutationVariables = {data?: CheckFavoritedStatusDto;params?: PostUserFavoritePlayersCheckStatusParams}

    /**
 * @summary Check favorited status for multiple players in a specific favorite type context.
Efficient for rendering UI (e.g., showing favorite icons on player lists).
 */
export const usePostUserFavoritePlayersCheckStatus = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>, TError,PostUserFavoritePlayersCheckStatusMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserFavoritePlayersCheckStatus>>,
        TError,
        PostUserFavoritePlayersCheckStatusMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserFavoritePlayersCheckStatusMutationOptions(options), queryClient);
    }
    /**
 * @summary Add a player to favorites for a specific workflow type.
Idempotent: Returns success even if already favorited. If already favorited, updates the note.
 */
export const postUserFavoritePlayersPlayerId = (
    playerId: number,
    params?: PostUserFavoritePlayersPlayerIdParams,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/FavoritePlayers/${playerId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostUserFavoritePlayersPlayerIdMutationKey = () => ['postUserFavoritePlayersPlayerId'] as const;

export const getPostUserFavoritePlayersPlayerIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>, TError,PostUserFavoritePlayersPlayerIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>, TError,PostUserFavoritePlayersPlayerIdMutationVariables, TContext> => {

const mutationKey = getPostUserFavoritePlayersPlayerIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>, PostUserFavoritePlayersPlayerIdMutationVariables> = (props) => {
          const {playerId,params} = props ?? {};

          return  postUserFavoritePlayersPlayerId(playerId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserFavoritePlayersPlayerIdMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>>

    export type PostUserFavoritePlayersPlayerIdMutationError = ErrorResult | ProblemDetails
    export type PostUserFavoritePlayersPlayerIdMutationVariables = {playerId: number;params?: PostUserFavoritePlayersPlayerIdParams}

    /**
 * @summary Add a player to favorites for a specific workflow type.
Idempotent: Returns success even if already favorited. If already favorited, updates the note.
 */
export const usePostUserFavoritePlayersPlayerId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>, TError,PostUserFavoritePlayersPlayerIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserFavoritePlayersPlayerId>>,
        TError,
        PostUserFavoritePlayersPlayerIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserFavoritePlayersPlayerIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove a player from favorites for a specific workflow type.
Idempotent: Returns success even if not currently favorited.
 */
export const deleteUserFavoritePlayersPlayerId = (
    playerId: number,
    params?: DeleteUserFavoritePlayersPlayerIdParams,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/FavoritePlayers/${playerId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteUserFavoritePlayersPlayerIdMutationKey = () => ['deleteUserFavoritePlayersPlayerId'] as const;

export const getDeleteUserFavoritePlayersPlayerIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>, TError,DeleteUserFavoritePlayersPlayerIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>, TError,DeleteUserFavoritePlayersPlayerIdMutationVariables, TContext> => {

const mutationKey = getDeleteUserFavoritePlayersPlayerIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>, DeleteUserFavoritePlayersPlayerIdMutationVariables> = (props) => {
          const {playerId,params} = props ?? {};

          return  deleteUserFavoritePlayersPlayerId(playerId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFavoritePlayersPlayerIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>>

    export type DeleteUserFavoritePlayersPlayerIdMutationError = ErrorResult | ProblemDetails
    export type DeleteUserFavoritePlayersPlayerIdMutationVariables = {playerId: number;params?: DeleteUserFavoritePlayersPlayerIdParams}

    /**
 * @summary Remove a player from favorites for a specific workflow type.
Idempotent: Returns success even if not currently favorited.
 */
export const useDeleteUserFavoritePlayersPlayerId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>, TError,DeleteUserFavoritePlayersPlayerIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserFavoritePlayersPlayerId>>,
        TError,
        DeleteUserFavoritePlayersPlayerIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserFavoritePlayersPlayerIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Add multiple players to favorites for a specific workflow type.
 */
export const postUserFavoritePlayersBatch = (
    batchFavoritePlayersDto?: BatchFavoritePlayersDto,
    params?: PostUserFavoritePlayersBatchParams,
 signal?: AbortSignal
) => {


      return fetcher<BatchFavoritePlayersResultDto>(
      {url: `/User/FavoritePlayers/Batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchFavoritePlayersDto,
        params, signal
    },
      );
    }




export const getPostUserFavoritePlayersBatchMutationKey = () => ['postUserFavoritePlayersBatch'] as const;

export const getPostUserFavoritePlayersBatchMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>, TError,PostUserFavoritePlayersBatchMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>, TError,PostUserFavoritePlayersBatchMutationVariables, TContext> => {

const mutationKey = getPostUserFavoritePlayersBatchMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>, PostUserFavoritePlayersBatchMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  postUserFavoritePlayersBatch(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserFavoritePlayersBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>>
    export type PostUserFavoritePlayersBatchMutationBody = BatchFavoritePlayersDto | undefined
    export type PostUserFavoritePlayersBatchMutationError = ErrorResult | ProblemDetails
    export type PostUserFavoritePlayersBatchMutationVariables = {data?: BatchFavoritePlayersDto;params?: PostUserFavoritePlayersBatchParams}

    /**
 * @summary Add multiple players to favorites for a specific workflow type.
 */
export const usePostUserFavoritePlayersBatch = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>, TError,PostUserFavoritePlayersBatchMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserFavoritePlayersBatch>>,
        TError,
        PostUserFavoritePlayersBatchMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserFavoritePlayersBatchMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove multiple players from favorites for a specific workflow type.
 */
export const deleteUserFavoritePlayersBatch = (
    batchFavoritePlayersDto?: BatchFavoritePlayersDto,
    params?: DeleteUserFavoritePlayersBatchParams,
 signal?: AbortSignal
) => {


      return fetcher<BatchFavoritePlayersResultDto>(
      {url: `/User/FavoritePlayers/Batch`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: batchFavoritePlayersDto,
        params, signal
    },
      );
    }




export const getDeleteUserFavoritePlayersBatchMutationKey = () => ['deleteUserFavoritePlayersBatch'] as const;

export const getDeleteUserFavoritePlayersBatchMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>, TError,DeleteUserFavoritePlayersBatchMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>, TError,DeleteUserFavoritePlayersBatchMutationVariables, TContext> => {

const mutationKey = getDeleteUserFavoritePlayersBatchMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>, DeleteUserFavoritePlayersBatchMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  deleteUserFavoritePlayersBatch(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFavoritePlayersBatchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>>
    export type DeleteUserFavoritePlayersBatchMutationBody = BatchFavoritePlayersDto | undefined
    export type DeleteUserFavoritePlayersBatchMutationError = ErrorResult | ProblemDetails
    export type DeleteUserFavoritePlayersBatchMutationVariables = {data?: BatchFavoritePlayersDto;params?: DeleteUserFavoritePlayersBatchParams}

    /**
 * @summary Remove multiple players from favorites for a specific workflow type.
 */
export const useDeleteUserFavoritePlayersBatch = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>, TError,DeleteUserFavoritePlayersBatchMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserFavoritePlayersBatch>>,
        TError,
        DeleteUserFavoritePlayersBatchMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserFavoritePlayersBatchMutationOptions(options), queryClient);
    }
    /**
 * @summary Clear all favorites for current user of a specific workflow type.
 */
export const deleteUserFavoritePlayersClearForType = (
    params?: DeleteUserFavoritePlayersClearForTypeParams,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/FavoritePlayers/ClearForType`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteUserFavoritePlayersClearForTypeMutationKey = () => ['deleteUserFavoritePlayersClearForType'] as const;

export const getDeleteUserFavoritePlayersClearForTypeMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>, TError,DeleteUserFavoritePlayersClearForTypeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>, TError,DeleteUserFavoritePlayersClearForTypeMutationVariables, TContext> => {

const mutationKey = getDeleteUserFavoritePlayersClearForTypeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>, DeleteUserFavoritePlayersClearForTypeMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteUserFavoritePlayersClearForType(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFavoritePlayersClearForTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>>

    export type DeleteUserFavoritePlayersClearForTypeMutationError = ErrorResult | ProblemDetails
    export type DeleteUserFavoritePlayersClearForTypeMutationVariables = {params?: DeleteUserFavoritePlayersClearForTypeParams}

    /**
 * @summary Clear all favorites for current user of a specific workflow type.
 */
export const useDeleteUserFavoritePlayersClearForType = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>, TError,DeleteUserFavoritePlayersClearForTypeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserFavoritePlayersClearForType>>,
        TError,
        DeleteUserFavoritePlayersClearForTypeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserFavoritePlayersClearForTypeMutationOptions(options), queryClient);
    }
    /**
 * @summary Clear ALL favorites for current user across ALL types.
Use with caution!
 */
export const userClearAllFavorites = (

 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/FavoritePlayers/All`, method: 'DELETE', signal
    },
      );
    }




export const getUserClearAllFavoritesMutationKey = () => ['userClearAllFavorites'] as const;

export const getUserClearAllFavoritesMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearAllFavorites>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userClearAllFavorites>>, TError,void, TContext> => {

const mutationKey = getUserClearAllFavoritesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClearAllFavorites>>, void> = () => {


          return  userClearAllFavorites()
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClearAllFavoritesMutationResult = NonNullable<Awaited<ReturnType<typeof userClearAllFavorites>>>

    export type UserClearAllFavoritesMutationError = ErrorResult | ProblemDetails


    /**
 * @summary Clear ALL favorites for current user across ALL types.
Use with caution!
 */
export const useUserClearAllFavorites = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearAllFavorites>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClearAllFavorites>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUserClearAllFavoritesMutationOptions(options), queryClient);
    }
    /**
 * @summary Get total count of favorites for current user, optionally filtered by favorite type.
 */
export const getUserFavoritePlayersCount = (
    params?: GetUserFavoritePlayersCountParams,
 signal?: AbortSignal
) => {


      return fetcher<number>(
      {url: `/User/FavoritePlayers/Count`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserFavoritePlayersCountQueryKey = (params?: GetUserFavoritePlayersCountParams,) => {
    return [
    `/User/FavoritePlayers/Count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserFavoritePlayersCountQueryOptions = <TData = Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError = ProblemDetails>(params?: GetUserFavoritePlayersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFavoritePlayersCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>> = ({ signal }) => getUserFavoritePlayersCount(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFavoritePlayersCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>>
export type GetUserFavoritePlayersCountQueryError = ProblemDetails


export function useGetUserFavoritePlayersCount<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError = ProblemDetails>(
 params: undefined |  GetUserFavoritePlayersCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersCount>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersCount<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFavoritePlayersCount>>,
          TError,
          Awaited<ReturnType<typeof getUserFavoritePlayersCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFavoritePlayersCount<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total count of favorites for current user, optionally filtered by favorite type.
 */

export function useGetUserFavoritePlayersCount<TData = Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError = ProblemDetails>(
 params?: GetUserFavoritePlayersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFavoritePlayersCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFavoritePlayersCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets recent games for a user near the time a specific game was simmed.
Used by the legacy GameView play-by-play page to surface the user's
other games simmed in the same window. Requires auth.
 */
export const getUserIdRecentGames = (
    id: number,
    params?: GetUserIdRecentGamesParams,
 signal?: AbortSignal
) => {


      return fetcher<RecentGameLeagueDto[]>(
      {url: `/User/${id}/RecentGames`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserIdRecentGamesQueryKey = (id: number,
    params?: GetUserIdRecentGamesParams,) => {
    return [
    `/User/${id}/RecentGames`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserIdRecentGamesQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdRecentGames>>, TError = unknown>(id: number,
    params?: GetUserIdRecentGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdRecentGamesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdRecentGames>>> = ({ signal }) => getUserIdRecentGames(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdRecentGamesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdRecentGames>>>
export type GetUserIdRecentGamesQueryError = unknown


export function useGetUserIdRecentGames<TData = Awaited<ReturnType<typeof getUserIdRecentGames>>, TError = unknown>(
 id: number,
    params: undefined |  GetUserIdRecentGamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdRecentGames>>,
          TError,
          Awaited<ReturnType<typeof getUserIdRecentGames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdRecentGames<TData = Awaited<ReturnType<typeof getUserIdRecentGames>>, TError = unknown>(
 id: number,
    params?: GetUserIdRecentGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdRecentGames>>,
          TError,
          Awaited<ReturnType<typeof getUserIdRecentGames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdRecentGames<TData = Awaited<ReturnType<typeof getUserIdRecentGames>>, TError = unknown>(
 id: number,
    params?: GetUserIdRecentGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets recent games for a user near the time a specific game was simmed.
Used by the legacy GameView play-by-play page to surface the user's
other games simmed in the same window. Requires auth.
 */

export function useGetUserIdRecentGames<TData = Awaited<ReturnType<typeof getUserIdRecentGames>>, TError = unknown>(
 id: number,
    params?: GetUserIdRecentGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdRecentGames>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdRecentGamesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Referral page data: shareable link + users you've referred.
 */
export const getUserReferralView = (

 signal?: AbortSignal
) => {


      return fetcher<ReferralViewResponse>(
      {url: `/User/Referral/View`, method: 'GET', signal
    },
      );
    }




export const getGetUserReferralViewQueryKey = () => {
    return [
    `/User/Referral/View`
    ] as const;
    }


export const getGetUserReferralViewQueryOptions = <TData = Awaited<ReturnType<typeof getUserReferralView>>, TError = ErrorResult | ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserReferralViewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserReferralView>>> = ({ signal }) => getUserReferralView(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserReferralViewQueryResult = NonNullable<Awaited<ReturnType<typeof getUserReferralView>>>
export type GetUserReferralViewQueryError = ErrorResult | ProblemDetails


export function useGetUserReferralView<TData = Awaited<ReturnType<typeof getUserReferralView>>, TError = ErrorResult | ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralView>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserReferralView<TData = Awaited<ReturnType<typeof getUserReferralView>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralView>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserReferralView<TData = Awaited<ReturnType<typeof getUserReferralView>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Referral page data: shareable link + users you've referred.
 */

export function useGetUserReferralView<TData = Awaited<ReturnType<typeof getUserReferralView>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserReferralView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserReferralViewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Send a referral invitation email.
 */
export const postUserReferral = (
    sendReferralDto?: SendReferralDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/User/Referral`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendReferralDto, signal
    },
      );
    }




export const getPostUserReferralMutationKey = () => ['postUserReferral'] as const;

export const getPostUserReferralMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserReferral>>, TError,PostUserReferralMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserReferral>>, TError,PostUserReferralMutationVariables, TContext> => {

const mutationKey = getPostUserReferralMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserReferral>>, PostUserReferralMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postUserReferral(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostUserReferralMutationResult = NonNullable<Awaited<ReturnType<typeof postUserReferral>>>
    export type PostUserReferralMutationBody = SendReferralDto | undefined
    export type PostUserReferralMutationError = ErrorResult | ProblemDetails
    export type PostUserReferralMutationVariables = {data?: SendReferralDto}

    /**
 * @summary Send a referral invitation email.
 */
export const usePostUserReferral = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserReferral>>, TError,PostUserReferralMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserReferral>>,
        TError,
        PostUserReferralMutationVariables,
        TContext
      > => {
      return useMutation(getPostUserReferralMutationOptions(options), queryClient);
    }
